<!-- categories For Desktop Screen Start -->
<ul class="list-group borderRadius10 cardShadow desktopViewDisaplay">
    <li class="list-group-item bgCustomPurple text-white font20 font500 border-0 p-3">Quick
        Categories</li>
    <li *ngFor="let cat of json2;let idx=index" class="list-group-item font16 mutedList border-0" [ngClass]="{'lightDarkPurple':idx%2===1}">
        <div class="row">
            <div class="col-3 col-md-2 col-lg-2 pe-0">
                <img [src]="cat.ImageURL" alt="logo1" />
            </div>
            <div class="col-9 col-md-10 col-lg-10">
                {{cat.Header}}
            </div>
        </div>
    </li>
</ul>
<!-- categories For Desktop Screen End -->

<!-- categories For Mobile Screen Start -->

<div class="row">
    <div class="col-md-12 mobileViewDisaplay">
        <form>
            <div class="input-group mb-3">
                <span class="input-group-text pinkBg border-end-0" id="basic-addon1">
                    <img src="../../../../assets/instaciti-new-img/Group (6).svg" class="img-fluid"
                        alt="categories" />
                </span>
                <select class="form-select customInput pinkBg text-white border-start-0">
                    <option value="">Quick Categories</option>
                    <option *ngFor="let cat of json2" [value]="cat.Header">{{cat.Header}}</option>
                </select>
            </div>
        </form>
    </div>
</div>

<!-- categories For Mobile Screen End -->